import Svg, { Path } from 'react-native-svg'

function Privacy() {
  return (
    <Svg width={64} height={64} viewBox="0 0 64 64">
      <Path d="M32 0A32 32 0 110 32 32 32 0 0132 0z" fill="#0070b6" />
      <Path
        d="M32 17l-13 5.455v8.182A17.142 17.142 0 0032 47a17.142 17.142 0 0013-16.364v-8.181zm0 14.986h10.111A14.785 14.785 0 0132 44.177V32H21.889v-7.773L32 19.986z"
        fill="#fff"
      />
      <Path d="M16 16h32v32H16z" fill="none" />
    </Svg>
  )
}

export { Privacy }
